module.exports = __webpack_public_path__ + "img/logo_u1992-3.9da7659a.svg";